// extracted by mini-css-extract-plugin
module.exports = {"successPage":"successPage___2hhnZ","imgWrap":"imgWrap___3bevg","content":"content___1rtpd","contentItem":"contentItem___2tnQV"};